/* istanbul ignore file */
export const getApplicationBaseUrl = function() {
    return document.location.origin;
};